import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
import { ReconstructedRobotCard, ScrapCard } from './tokens.js';
export const EverythingMachineCard = defineGameCard({
    id: 'everything_machine',
    gameplay: {
        type: 'UNIT', cost: 7, minimumCost: 4,
        baseStats: { attack: 6, health: 6 },
        effectiveCost(state, instanceId, baseCost) {
            const ownerId = state.instances[instanceId]?.ownerId;
            const assemblies = ownerId === undefined ? 0 : Object.values(state.instances).filter((instance) => instance.zone === 'board' && instance.controllerId === ownerId && instance.defId === ReconstructedRobotCard.id).length;
            return baseCost - assemblies;
        },
    },
    presentation: {
        name: 'Машина из всего',
        description: 'Стоит на 1 дешевле за каждого вашего Восстановленного робота на поле (минимум 4). При раскрытии утилизирует весь ваш Хлам и получает +1/+1 за каждую утилизированную карту.',
        glyph: {
            colors: ['#10213A', '#4A494F', '#23252F', '#81392B', '#766550'],
            rows: [
                '....................',
                '........11111.......',
                '.......1232321......',
                '...11111222221111...',
                '..1444425552514411..',
                '.114344322222244411.',
                '.113341322522214411.',
                '..1331132222221111..',
                '.12531322322221331..',
                '11323.1121111311121.',
                '13352113112213.33311',
                '13322114445554133211',
                '13322145544555433211',
                '11314433114411221131',
                '.13444133..111111331',
                '.1134315511131255111',
                '..11111521113122211.',
                '.11111122111112221..',
                '..111111111111111...',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('reconstructed_robot'), cardRef('scrap')],
    abilities: [onAppear((ctx) => {
            const self = ctx.self;
            const consumed = ctx.q.unitsOf(self.controllerId)
                .filter((unit) => unit.defId === ScrapCard.id);
            for (const unit of consumed)
                ctx.ops.consumeCard(unit.id);
            if (consumed.length > 0) {
                ctx.ops.modifyStat(self.id, 'attack', consumed.length);
                ctx.ops.modifyStat(self.id, 'maxHealth', consumed.length);
                ctx.ops.modifyStat(self.id, 'health', consumed.length);
            }
        }, { cause: 'played' })],
    ui: {
        mechanics: ['scrap'],
        capabilities: { tracksTokenDeaths: true },
    },
});
//# sourceMappingURL=everything-machine.js.map